import { useState, useEffect } from "react";
import { useAccount } from "wagmi"; // Assuming you're using the wagmi library

// Custom hook to check if the expectedChainId matches the current chainId
export default function useCheckChainId() {
  const { chainId } = useAccount(); // Gets the current network information from wagmi
  const expectedChainId = 43113; // The specific chain ID to match against
  const address = useAccount();

  const currentChainId = address?.chainId;

  const [isMatchingChain, setIsMatchingChain] = useState(true);
  // console.log("currentChainId", currentChainId);
  // console.log("expectedChainId", expectedChainId);
  // console.log("isMatchingChain", isMatchingChain);
  useEffect(() => {
    if (currentChainId !== undefined) {
      setIsMatchingChain(currentChainId === expectedChainId);
    } else {
      setIsMatchingChain(false);
    }
  }, [currentChainId, expectedChainId]);

  return isMatchingChain;
}
